import Highcharts from './_highcharts-base';
import {Options, AxisLabelsFormatterContextObject} from 'highcharts';

export default function () {
    $(() => {
        for (const chart of $('.diff-chart')) {
            const options: Options = {
                chart: {
                    type: 'bar',
                    width: 660,
                    height: 400,
                    marginLeft: 30,
                    marginRight: 30,
                },
                yAxis: {
                    min: -3,
                    max: 3,
                    tickInterval: 1,
                    title: {
                        text: 'Score Z',
                        style: {
                            fontSize: '8pt',
                            color: 'black'
                        }
                    },
                    labels: {
                        useHTML: true,
                        style: {
                            fontSize: '9pt',
                            color: 'black'
                        },
                        formatter: function (this: AxisLabelsFormatterContextObject) {
                            return Math.abs(this.value).toString();
                        },
                    },
                },
                plotOptions: {
                    columnrange: {
                        grouping: false
                    },
                },
            };
            new Highcharts.Chart(
                chart,
                $.extend(true, {}, options, $(chart).data('chart'))
            );
        }
    });
}